import React from "react";
import { Hero } from "../Hero";
import { Trustpilot } from "../Trustpilot";
import { QuoteFormAndSafesitePromise } from "../QuoteFormAndSafesitePromise";
import { ProductTypeFeed } from "../ProductTypeFeed";
import { ContentAndQuoteFlexi } from "../FlexibleComponents/ContentAndQuote";
import { ContentAndImageFlexi } from "../FlexibleComponents/ContentAndImage";
import { ContentAndVideoFlexi } from "../FlexibleComponents/ContentAndVideo";
import { ContentFlexi } from "../FlexibleComponents/Content";
import { AreasCoveredAndSafeSiteBanner } from "../AreasCoveredAndSafeSiteBanner";
import { Testimonials } from "../Testimonials";
import { FeedbackForm } from "../FeedbackForm";
import { ContactMapAndForm } from "../ContactMapAndForm";
import { FullWidthBanner } from "../FullWidthBanner";
import { ProductList } from "../ProductList";
import { Carousel } from "../Carousel";
import { Faqs } from "../Faqs";
import { Video } from "../Video";
import { Table } from "../Table";
import { RelatedArticles } from "../RelatedArticles";
import { RelatedCaseStudies } from "../RelatedCaseStudies";
import { RelatedProducts } from "../RelatedProducts";
import { ThreeDView } from "../ThreeDView";
import { Media } from "../Media";
import { ContentAndMediaLandingPage } from "../ContentAndMediaLandingPage";
import { ContentLandingPage } from "../ContentLandingPage";
import { HeroLandingPage } from "../HeroLandingPage";
import { SpacerLandingPage } from "../SpacerLandingPage";
import { CustomTiles } from "../CustomTiles";
import { SubscribeToNewsletter } from "../SubscribeToNewsletter";
import { Accreditations } from "../Accreditations";

export const Component = ({ component, source }) => {
  if (component.fieldGroupName) {
    switch (component.fieldGroupName) {
      case "page_Components_Components_Hero":
        return (
          <Hero
            heading={component.heading}
            text={component.text}
            desktopImage={component.desktopImage.mediaItemUrl}
            mobileImage={component.mobileImage.mediaItemUrl}
          />
        );
      case "page_Components_Components_ContentAndVideo":
        return (
          <ContentAndVideoFlexi
            content={component.content}
            video={component.video}
            background={component.background}
            placement={component.placement}
          />
        );
      case "page_Components_Components_Testimonials":
        return (
          <Testimonials testimonials={component.testimonials} source={source} />
        );
      case "page_Components_Components_Contact":
        return <ContactMapAndForm />;
      case "page_Components_Components_ContentQuoteForm":
        return (
          <ContentAndQuoteFlexi content={component.content} source={source} />
        );
      case "page_Components_Components_ContentAndImage":
        return (
          <ContentAndImageFlexi
            content={component.content}
            image={component.image}
            background={component.background}
            placement={component.placement}
          />
        );
      case "page_Components_Components_AreasCoveredAndSafesitePromiseBanner":
        return <AreasCoveredAndSafeSiteBanner />;
      case "page_Components_Components_TrustpilotReviews":
        return <Trustpilot businessunitId="59e0886b0000ff0005ad8ae5" />;
      case "page_Components_Components_ProductTypeFeed":
        return (
          <ProductTypeFeed
            productTypes={component.productTypes}
            heading={component.heading}
            productCardStyle={component.productCardStyle}
          />
        );
      case "page_Components_Components_FullWidthQuoteForm":
        return <QuoteFormAndSafesitePromise source={source} />;
      case "page_Components_Components_Content":
        return (
          <ContentFlexi
            content={component.content}
            background={component.background}
          />
        );
      case "page_Components_Components_FeedbackForm":
        return <FeedbackForm />;
      case "page_Components_Components_FullWidthBanner":
        return <FullWidthBanner
          mobileImage={component.mobileImage}
          desktopImage={component.desktopImage}
          pdfLink={component?.pdfLink?.localFile?.publicURL}
        />;
      case "page_Components_Components_ProductsNew":
        return component.products.length > 0 && (
          <ProductList
            products={component.products}
            grey={component.background === 'grey'}
          />
        );
      case "page_Components_Components_CarouselNew":
        return <Carousel
          images={component.images.map(image => image.image)}
          fullWidth={component.fullWidth}
          autoScroll={component.autoScroll}
          delay={component.delay}
        />;
      case "page_Components_Components_FaqsNew":
        return <Faqs
          items={component.faqs}
          fullWidth={component.fullWidth}
          background={component.background}
        />;
      case "page_Components_Components_VideoComponentNew":
        return <Video
          video={component.videoEmbed}
          aspectWidth={component.aspectWidth}
          aspectHeight={component.aspectHeight}
          fullWidth={component.fullWidth}
          background={component.background}
          title={component.title}
        />;
      case "page_Components_Components_TrustpilotNew":
        return <Trustpilot
          background={component.background}
        />;
      case "page_Components_Components_QuoteFormAndSafesitePromiseNew":
        return <QuoteFormAndSafesitePromise
          source={source}
        />;
      case "page_Components_Components_TableNew":
        return <Table
          title={component.title}
          specifications={component.specifications}
          products={component.products}
          showProductFeaturedImageAndTitle={component.showProductFeaturedImageAndTitle}
        />;
      case "page_Components_Components_RelatedArticlesNew":
        return <RelatedArticles
          articles={component.articles}
          inversed={component.background === 'white'}
        />;
      case "page_Components_Components_RelatedCaseStudiesNew":
        return <RelatedCaseStudies
          caseStudies={component.caseStudies}
          inversed={component.background === 'white'}
        />;
      case "page_Components_Components_RelatedProductsNew":
        return <RelatedProducts
          products={component.products}
          inversed={component.background === 'white'}
        />;
      case "page_Components_Components_ThreeDViewNew":
        return <ThreeDView
          threeDViewEmbed={component.threedViewEmbed}
          fullWidth={component.fullWidth}
        />;
      case "page_Components_Components_MediaNew":
        // Lovely hack
        component.media.video = component.media.videoAlt

        return <Media
          mobileColumns={component.mobileColumns}
          columns={component.columns}
          textAlign={component.textAlign}
          justifyContent={component.justifyContent}
          media={component.media}
          background={component.background}
          zoom={component.zoom}
        />;
      case "page_Components_Components_ContentAndImageNew":
        return <ContentAndMediaLandingPage
          title={component.titleGroup}
          titleLink={component.titleLink}
          content={component.content}
          list={component.list}
          button={component.button}
          image={component.image}
          imageLink={component.imageLink}
          placement={component.placement}
          background={component.background}
          mediaType={component.mediaType}
          video={component.videoAlt?.publicUrl}
          videoPoster={component.videoPoster}
          oembed={component.oembed}
          carouselImages={component.carouselImages}
          autoScroll={component.autoScroll}
          delay={component.delay}
        />;
      case "page_Components_Components_ContentNew":
        return <ContentLandingPage
          title={component.titleGroup}
          content={component.content}
          background={component.background}
          images={component.images}
          align={component.align}
        />;
      case "page_Components_Components_HeroNew":
        return <HeroLandingPage
          title={component.titleGroup}
          content={component.content}
          button={component.button}
          desktopImage={component.desktopImage?.mediaItemUrl}
          mobileImage={component.mobileImage?.mediaItemUrl}
          fullHeight={component.fullHeight}
          overlayColour={component.overlayColour}
          overlayOpacity={component.overlayOpacity}
          video={component.videoFile?.publicUrl}
          videoPoster={component.videoPoster}
          background={component.background}
          mobileBackground={component.mobileBackground}
          uppercaseTitle={component.uppercaseTitle}
          darkText={component.darkText}
          textShadow={component.textShadow}
          carouselImages={component.carouselImages}
          autoScroll={component.autoScroll}
          delay={component.delay}
        />;
      case "page_Components_Components_SpacerNew":
        return <SpacerLandingPage
          background={component.background}
        />;
      case "page_Components_Components_CustomTiles":
        return <CustomTiles
          overhang={component.overhang}
          overhangMobile={component.overhangMobile}
          background={component.background}
          title={component.titleGroup}
          content={component.content}
          button={component.button}
          products={component.products}
        />;
      case "page_Components_Components_SubscribeToNewsletter":
        return <SubscribeToNewsletter
          background={component.background}
          title={component.title}
          subText={component.subText}
          disclaimer={component.disclaimer}
          confirmation={component.confirmation}
          icon={component.icon}
          image={component.image}
        />;
      case "page_Components_Components_Accreditations":
        return <Accreditations
          global={component.global}
          images={component.images}
          autoScroll={component.autoScroll}
          delay={component.delay}
        />;
      default:
        return <></>;
    }
  }
};
